import React from "react";

import SupplierProductView from "../../containers/SupplierDetail/SupplierProductView";

const SupplierProductsPage = () => {
  return (
    <div>
      <SupplierProductView />
    </div>
  );
};

export default SupplierProductsPage;
